import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import MoneyViewLogo from "../../assets/images/congratulations/incred.svg";
import Celebration from "../../assets/images/congratulations/gift.png";
import FinlabLogo from "../../assets/images/header/logoback.svg";
import CryptoJS from "crypto-js"; // Import CryptoJS for decryption
import { useLocation } from "react-router-dom"; // Import useLocation for URL parsing
import axios from "axios"; // Import axios for API calls
import { API_URL } from "../../config/constant"; // Import API_URL for endpoint configuration

export default function Index() {
  // Function to detect the user is on a which device
  const isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const buttonText = "Download App";
  const buttonLink = isApple
    ? "#"
    : "https://play.google.com/store/apps/details?id=com.incred.customer";

  const [applicationId, setApplicationId] = useState(null);
  const [requestID, setRequestID] = useState(null);
  const [offerStatus, setOfferStatus] = useState(null); // Add state for offer status
  const [offer, setOffer] = useState(null); // Add state for offer
  const [loading, setLoading] = useState(false); // Loader state
  const location = useLocation();

  useEffect(() => {
    setLoading(true); // Start loader
    const queryParams = new URLSearchParams(location.search);
    const encryptedAppId = queryParams.get("_ref");
    const encryptedCustId = queryParams.get("_cust");

    if (encryptedAppId && encryptedCustId) {
      try {
        const decryptedAppId = CryptoJS.AES.decrypt(
          decodeURIComponent(encryptedAppId),
          "finlab-encryption-key"
        ).toString(CryptoJS.enc.Utf8);
        const decryptedCustId = CryptoJS.AES.decrypt(
          decodeURIComponent(encryptedCustId),
          "finlab-encryption-key"
        ).toString(CryptoJS.enc.Utf8);

        // Call the /request-offer API with the decrypted Application ID
        axios
          .post(`${API_URL}incred/request-offer`, {
            applicationId: decryptedAppId,
          })
          .then((response) => {
            if (response.data?.status === true) {
              const { APPLICATION_ID, REQUEST_ID } = response.data.response;
              setApplicationId(APPLICATION_ID);
              setRequestID(REQUEST_ID);
              // Call the /offer-status API with APPLICATION_ID and REQUEST_ID
              axios
                .post(`${API_URL}incred/offer-status`, {
                  applicationId: APPLICATION_ID,
                  requestId: REQUEST_ID,
                })
                .then((statusResponse) => {
                  const { data } = statusResponse;
                  const { response } = data;
                  console.log("Offer Status Response:", response);
                  const status = response?.STATUS;
                  setOfferStatus(status); // Set the offer status
                  if (status === "COMPLETED") {
                    // Set the first offer if available
                    if (
                      Array.isArray(response?.LOAN_OFFERS) &&
                      response.LOAN_OFFERS.length > 0
                    ) {
                      setOffer(response.LOAN_OFFERS[0]);
                    } else {
                      setOffer(null);
                    }
                  }
                  setLoading(false); // Stop loader
                })
                .catch((error) => {
                  console.error("Error fetching offer status:", error);
                  setLoading(false); // Stop loader
                });
            } else {
              setLoading(false); // Stop loader if status is not true
            }
          })
          .catch((error) => {
            console.error("Error fetching offer:", error);
            setLoading(false); // Stop loader
          });
      } catch (error) {
        console.error("Error decrypting data:", error);
        setLoading(false); // Stop loader
      }
    } else {
      setLoading(false); // Stop loader if params missing
    }
  }, [location.search]);

  const handleCheckOfferStatus = () => {
    if (
      applicationId &&
      (offerStatus === "PENDING" || offerStatus === "ERROR")
    ) {
      setLoading(true); // Start loader
      axios
        .post(`${API_URL}incred/offer-status`, {
          applicationId: applicationId,
          requestId: requestID, // Assuming requestID is used as requestId
        })
        .then((statusResponse) => {
          const { data } = statusResponse;
          const { response } = data;
          console.log("Offer Status Response:", response);
          const status = response?.STATUS;
          setOfferStatus(status); // Set the offer status
          if (status === "COMPLETED") {
            // Set the first offer if available
            if (
              Array.isArray(response?.LOAN_OFFERS) &&
              response.LOAN_OFFERS.length > 0
            ) {
              setOffer(response.LOAN_OFFERS[0]);
            } else {
              setOffer(null);
            }
          }
          setOfferStatus(status); // Update the offer status
          setLoading(false); // Stop loader
        })
        .catch((error) => {
          console.error("Error fetching offer status:", error);
          setLoading(false); // Stop loader
        });
    }
  };

  return (
    <Container fluid className="loan-offer-container">
      {/* Header Section */}
      <Row className="congratulations-header align-items-center">
        <Col xs={12} md={6} className="text-start">
          <img
            src={FinlabLogo}
            alt="Finlab Logo"
            className="congratulations-logo"
          />
          <span className="mx-2">in partnership with</span>
          <img
            src={MoneyViewLogo}
            alt="MoneyView Logo"
            className="congratulations-logo"
          />
        </Col>
        <Col xs={12} md={6} className="text-end mt-3 mt-md-0">
          <i className="bi bi-person-circle congratulations-user-icon"></i>
        </Col>
      </Row>

      {/* Content Section */}
      <Row className="congratulations-content text-center justify-content-center my-4">
        <Col xs={12} sm={10} md={8} lg={6}>
          <div className="congratulations-offer-card">
            {loading ? (
              <div style={{ padding: "40px 0" }}>
                <Spinner animation="border" role="status" />
                <div>Loading...</div>
              </div>
            ) : (
              <>
                {offerStatus === "PENDING" && (
                  <>
                    <h2>Status: PENDING</h2>
                    <p>
                      Your application is currently being processed. Please
                      check back later.
                    </p>
                    <Button
                      variant="primary"
                      className="check-offer-button"
                      onClick={handleCheckOfferStatus}
                    >
                      Check Offer Status
                    </Button>
                  </>
                )}
                {offerStatus === "REJECTED" && (
                  <>
                    <h2>Status: REJECTED</h2>
                    <p>
                      Unfortunately, your application has been rejected. Please
                      contact support for further assistance.
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="danger"
                        className="contact-support-button"
                        onClick={() => window.open("mailto:support@finlab.com")}
                      >
                        Contact Support
                      </Button>
                      <Button
                        variant="secondary"
                        className="go-home-button"
                        onClick={() => (window.location.href = "/")}
                      >
                        Back to Home
                      </Button>
                    </div>
                  </>
                )}
                {offerStatus === "ERROR" && (
                  <>
                    <h2>Status: ERROR</h2>
                    <p>
                      Something went wrong - please try again. If the problem
                      persists, contact support.
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="outline-primary"
                        className="refresh-offer-button"
                        onClick={handleCheckOfferStatus}
                      >
                        Refresh
                      </Button>
                    </div>
                  </>
                )}
                {offerStatus === "COMPLETED" && (
                  <>
                    <div className="congratulations-icon-container">
                      <i className="bi bi-gift-fill congratulations-offer-icon">
                        <img
                          src={Celebration}
                          alt="Celebration symbol"
                          className="celebration-symbol"
                        />
                      </i>
                    </div>
                    <h2>Congratulations!</h2>
                    {offer ? (
                      <>
                        <p>
                          You are eligible for a loan of{" "}
                          <strong>
                            ₹{offer.LOAN_AMOUNT?.toLocaleString() || "N/A"}*
                          </strong>
                        </p>
                        <p>
                          Tenure:{" "}
                          <strong>
                            {offer.LOAN_MAX_TENURE || "N/A"} months
                          </strong>
                        </p>
                        <p>
                          Interest Rate:{" "}
                          <strong>{offer.LOAN_RATE || "N/A"}%</strong>
                        </p>
                        <p>
                          Processing Fee:{" "}
                          <strong>{offer.PROCESSING_FEE || "N/A"}%</strong>
                        </p>
                      </>
                    ) : (
                      <p>No offer details available.</p>
                    )}
                    <p>Get loan offers up to ₹5 Lakh on our app</p>
                    <p>
                      Application ID: <strong>{applicationId || "N/A"}</strong>
                    </p>
                    <p className="congratulations-disclaimer">
                      *This is a tentative loan offer and the final loan offer
                      might be subject to change
                    </p>
                    <Button
                      variant="success"
                      className="congratulations-download-button"
                      onClick={() => window.open(buttonLink, "_blank")}
                    >
                      {buttonText}
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* Footer Section */}
      <Row className="congratulations-footer text-center">
        <Col xs={12}>
          <p>Safe and secure &nbsp; | &nbsp; Privacy</p>
          <p>© 2024 Finlab.One Pvt. Ltd.</p>
        </Col>
      </Row>
    </Container>
  );
}
